import * as React from 'react'
import {HeroImageButton, HeroImageContainer, HeroImageTextWrapper, HeroImageTitle} from './HeroImage.elements'
import Analytics from "@lib/Analytics";

type HeroImageProps = {
  title: string;
  buttonText: string;
  url: string;
}

export const HeroImage: React.FunctionComponent<HeroImageProps> = ({title, buttonText, url}) => {

  const onClickLink = () => {
    Analytics.log('Click', {
      location: 'apply-button'
    });
  }

  return (
    <HeroImageContainer>
      <HeroImageTextWrapper>
        <HeroImageTitle dangerouslySetInnerHTML={{__html: title}} />
        <HeroImageButton href={url} onClick={onClickLink} dangerouslySetInnerHTML={{__html: buttonText}} />
      </HeroImageTextWrapper>
    </HeroImageContainer>
  )
}
